'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setYotpoLoyaltyCart = exports.setCartAbandonedTime = exports.checkIfCartWasAbandoned = exports.toggleShippingCartAttr = exports.toggleInlineCart = exports.closeInlineCart = exports.openInlineCart = undefined;

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _utils = require('spritespin/release/src/utils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sessionStorageName = 'pitviper_cart_abondoned';
// this is in milliseconds
var allowedAbandonedTimeLimit = 7200000;

var openInlineCart = exports.openInlineCart = function openInlineCart(data) {
  var inlineCart = document.querySelector(_Dom2.default.inlineCart);
  inlineCart.classList.add('is-open');
};

var closeInlineCart = exports.closeInlineCart = function closeInlineCart(data) {
  var inlineCart = document.querySelector(_Dom2.default.inlineCart);
  inlineCart.classList.remove('is-open');
};

var toggleInlineCart = exports.toggleInlineCart = function toggleInlineCart(data) {
  var inlineCart = document.querySelector(_Dom2.default.inlineCart);
  inlineCart.classList.toggle('is-open');
};

var toggleShippingCartAttr = exports.toggleShippingCartAttr = function toggleShippingCartAttr(message, data) {
  var el = data.currentTarget;
  var isChecked = el.checked;
  var discrete_shipping = isChecked ? true : null;
  var attributes = Object.assign({}, window.bvaccel.state.cart.attributes, { discrete_shipping: discrete_shipping });
  fetch('/cart/update.js', {
    method: 'POST',
    body: JSON.stringify({ attributes: attributes }),
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' }
  }).then(function (cart) {
    return cart.json();
  }).then(function (cart) {
    return window.bvaccel.state.cart = cart;
  });
};

var checkIfCartWasAbandoned = exports.checkIfCartWasAbandoned = function checkIfCartWasAbandoned() {
  var currentTimestamp = new Date().getTime();
  var cartAbandonedTime = getAbandonedCartTime(currentTimestamp);
  var overAbandonedTimeLimit = currentTimestamp > cartAbandonedTime + allowedAbandonedTimeLimit;

  setTimeout(function () {
    var cartHasItems = !!CartJS.cart.item_count;
    if (cartHasItems && overAbandonedTimeLimit) {
      setCartAbandonedTime();
      PubSub.publish(_Constants2.default.openInlineCart, {});
    }
  }, 2000);
};

var setCartAbandonedTime = exports.setCartAbandonedTime = function setCartAbandonedTime() {
  var currentTimestamp = new Date().getTime();
  localStorage.setItem(sessionStorageName, currentTimestamp);
};

var getAbandonedCartTime = function getAbandonedCartTime(currentTimestamp) {
  if (localStorage.getItem(sessionStorageName) === null) return currentTimestamp;
  return parseInt(localStorage.getItem(sessionStorageName), 10);
};
var yotpoApply = function yotpoApply(code, action) {
  var checkoutContainer = document.createElement('div');
  checkoutContainer.id = "checkout-container";
  checkoutContainer.style.display = "none";
  var checkoutCart = document.getElementById('checkout-cart-block');
  checkoutCart.appendChild(checkoutContainer);
  var discountApplyUrl = window.location.href + "cart/checkout?discount=" + code + "&t=" + Date.now();
  fetch(discountApplyUrl).then(function (response) {
    return response.text();
  }).then(function (data) {
    checkoutContainer.innerHTML = data;
    var total = checkoutContainer.querySelector(".payment-due__price").textContent.trim();
    var discontsPrice = document.querySelector(".inline-cart__total-discounted");
    var oldPrice = document.querySelector(".cart__total-amount");
    discontsPrice.innerHTML = total;
    oldPrice.classList.add("quickshop__price-compare", "price__discount-value");
  });
};

var setYotpoLoyaltyCart = exports.setYotpoLoyaltyCart = function setYotpoLoyaltyCart() {
  var selectedLoyaltyHeading = window.localStorage.getItem('yotpo-loyalty-heading');
  var selectedLoyaltyReward = window.localStorage.getItem('yotpo-loyalty-reward');

  if (selectedLoyaltyHeading && selectedLoyaltyReward) {
    (0, _utils.$)('[data-yotpo-heading]').text(selectedLoyaltyHeading);
    (0, _utils.$)('[data-yotpo-header] .yotpo-btn').css({ 'cursor': 'default' });
    (0, _utils.$)('[data-yotpo-total]').hide();
    (0, _utils.$)('[data-yotpo-header] .yotpo-chevron').hide();
    (0, _utils.$)('.yotpo-header').removeAttr('data-yotpo-header');
    yotpoApply(selectedLoyaltyReward);
  } else {
    var checkForYotpo = window.setInterval(function () {
      var $redemptionSnippet = (0, _utils.$)('.yotpo-coupons-redemption-widget');
      (0, _utils.$)('[data-yotpo-coupons]').empty();

      if (!$redemptionSnippet.length) return;

      var balance = parseInt($redemptionSnippet.find('.yotpo-points-balance-text').eq(1).text().trim());
      if (isNaN(balance)) return;

      var $details = (0, _utils.$)('.yotpo-redemption-option-details');
      var rewards = [];

      (0, _utils.$)('[data-yotpo-total]').text('You have ' + balance + ' PitCoins™');
      window.localStorage.setItem('yotpo-points-balance', balance);

      if (!$details.length) return;

      $details.each(function () {
        var $cost = (0, _utils.$)(this).find('.yotpo-redemption-option-cost');
        var $reward = (0, _utils.$)(this).find('.yotpo-redemption-option-reward');
        var $button = (0, _utils.$)(this).closest('.yotpo-redemption-option').find('button');
        if (!$cost.length || !$reward.length || !$button.length) return;

        var cost = parseInt($cost.text().trim());
        var text = $reward.text().trim();
        $button.attr('data-cost', cost).attr('data-text', text);

        rewards.push({
          cost: cost,
          text: text
        });
      });

      if (rewards.length === 0) return;

      var availableRewards = rewards.filter(function (r) {
        return r.cost < balance;
      });
      var totalRewards = availableRewards.length;

      if (totalRewards === 0) {
        var noCoinsMessage = (0, _utils.$)('[data-yotpo-header]').data('no-pitcoins').trim();
        (0, _utils.$)('[data-yotpo-coupons]').append('<div class="yotpo-coupon">' + noCoinsMessage + '</div>');
        (0, _utils.$)('.yotpo-body').addClass('no-pitcoins');
      } else {
        (0, _utils.$)('.yotpo-body').removeClass('no-pitcoins');
        (0, _utils.$)('[data-yotpo-coupons]').each(function () {
          var _this = this;

          availableRewards.map(function (reward) {
            if (window.swellAPI) {
              var options = window.swellAPI.getActiveRedemptionOptions();
              var id = null;
              if (options.find(function (option) {
                return option.costInPoints === reward.cost;
              })) {
                id = options.find(function (option) {
                  return option.costInPoints === reward.cost;
                }).id;
              }
              var rewardOption = id ? '<div class="yotpo-coupon" data-yotpo-coupon data-cost="' + reward.cost + '" data-yotpo-id="' + id + '"> ' + reward.text + '</div>' : '<div class="yotpo-coupon" data-yotpo-coupon data-cost="' + reward.cost + '"> ' + reward.text + '</div>';
              (0, _utils.$)(_this).append(rewardOption);
            }
          });
        });
      }

      if (balance > 0) {
        window.clearInterval(checkForYotpo);
      }
    }, 1000);
  }
};